import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Users Redux States
import {
  GET_USERS,
  GET_USER,
  CREATE_USER,
  EDIT_USER,
  ACTIVATE_USER,
  RESET_USER_PASSWORD,
} from "./actionTypes";
import {
  setUsers,
  apiError,
  setUser,
  createUserSuccess,
  editUserSuccess,
  activateUserSuccess,
  setResetUserPasswordSuccess
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* resetUserPassword({ payload: { password, repeatPassword, userId, companyId } }){
  try {
    const response = yield call(axios.patch, `/user?id=${userId}&client_id=${companyId}`,{
      password: password,
      repeat_password: repeatPassword,
    })
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(setResetUserPasswordSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
            message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message = "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getUsers({ payload: { idCompany, page, qnt, name, email, isForm  } }) {
  try {
    const response = yield call(
      axios.get,
      `/user?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (email ? `&email=${email}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setUsers(response.data.data, qnt, idCompany));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createUser({ payload: { newUserValues, idCompany } }) {
  try {
    const response = yield call(
      axios.post,
      `/user?${idCompany ? `&client_id=${idCompany}` : ""}`,
      newUserValues
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(createUserSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getUser({ payload: { idUser, idCompany, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/user?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idUser ? `&id=${idUser}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setUser(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editUser({ payload: { idUser, newUserValues, idCompany } }) {
  try {
    const response = yield call(
      axios.patch,
      `/user?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idUser ? `&id=${idUser}` : "")
      }`,
      newUserValues
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editUserSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* activateUser({ payload: { idUser, active, idCompany } }) {
  try {
    const response = yield call(
      axios.patch,
      `/user/activate?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idUser ? `&id=${idUser}` : "")
      }`,
      active
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(activateUserSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchUser() {
  yield takeEvery(GET_USERS, getUsers);
}
export function* watchResetUserPasword() {
  yield takeEvery(RESET_USER_PASSWORD,resetUserPassword);
}
export function* watchCreateUser() {
  yield takeEvery(CREATE_USER, createUser);
}
export function* watchGetUser() {
  yield takeEvery(GET_USER, getUser);
}
export function* watchEditUser() {
  yield takeEvery(EDIT_USER, editUser);
}
export function* watchActivateUser() {
  yield takeEvery(ACTIVATE_USER, activateUser);
}
function* authSaga() {
  yield all([
    fork(watchUser),
    fork(watchGetUser),
    fork(watchCreateUser),
    fork(watchEditUser),
    fork(watchActivateUser),
    fork(watchResetUserPasword)
  ]);
}

export default authSaga;
